import React, { useEffect } from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ListPage from './Pages/List/Index';
import ShowPage from './Pages/Show/Index';

import { useContext } from './Context';

export default function Index() {
    const { dispatch, actions, state } = useContext();

    useEffect(() => {
        actions.getToken(dispatch);
    }, [])

    return (
        <Router>
            <Routes>
                <Route path="/admin/ai_sessions" element={<ListPage />}>
                    <Route path="/admin/ai_sessions/:id" element={<ShowPage />} />
                </Route>
            </Routes>
        </Router>
    );
}
